import { FormEvent, useCallback } from 'react';
import { faArrowLeft, faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { useClientContext } from 'client/context';
import { UserReset } from 'client/voladeum/auth/types';
import { selectUser } from 'ducks/user/selectors';
import { clearUser, setToken } from 'ducks/user/slices';
import { Button } from 'framework/button';
import { Icon } from 'framework/Icon';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import cn from './EmailPage.module.scss';
const { PUBLIC_URL } = process.env;

export default () => {
  const dispatch = useAppDispatch();
  const { email } = useAppSelector(selectUser);

  const { Voladeum, handleError } = useClientContext();

  const logout = useCallback(() => dispatch(clearUser()), [dispatch]);

  const onSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        const payload: UserReset = { login: email };
        const res = await Voladeum.auth.resendEmail(payload);
        dispatch(setToken({ token: res.data }));
      } catch (err) {
        handleError(err);
      }
    },
    [Voladeum.auth, dispatch, email, handleError]
  );

  return (
    <div className={cn.page}>
      <div className={cn.container}>
        <form className={cn.form} onSubmit={onSubmit}>
          <div className={cn.logo}>
            <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
          </div>
          <p className={cn.message}>
            Account has not been verified. Please look for an email from system@voladeum.com and
            click the link.
          </p>
          <Button
            left_icon={faEnvelope}
            type="submit"
            width="100%"
            variant="secondary"
            height="36px"
            shadow
          >
            Resend email
          </Button>
        </form>
        <a className={cn.back} onClick={logout}>
          <Icon icon={faArrowLeft} size="14px" width="30px" />
          Sign in
        </a>
      </div>
    </div>
  );
};
